<template>
  <v-footer
      
      app
      class="degrade footer-font"
  >
    <span class="white--text font-weight-bold mr-2">v1.0</span> 
    <span class="white--text">&copy; 2019 - {{ new Date().getFullYear() }}. Todos os direitos reservados.</span> 
    <v-spacer></v-spacer>
    <span class="white--text">UP - Tecnologia em sistemas</span>
  </v-footer>
</template>
<script>
export default {
}
</script>

<style>

  .footer-font{
    font-size: 0.8rem
  }

  .degrade{
    background: rgb(2,177,238);
    background: linear-gradient(90deg, rgba(2,177,238,1) 0%, rgba(37,197,213,1) 90%);
  }

</style>